import React, { useEffect, useState } from "react";
import "./AttendanceWidget.css";
import {
  useCreateAttendance,
  useGetLatestAttendance,
} from "../../hooks/useAttendance";
import {
  formatDate,
  formatTime,
  getAddressFromCoords,
} from "../../util/common";
import { useGlobal } from "../../contexts/GlobalContext";
import { toast } from "react-toastify";

function AttendanceWidget() {
  const [latestAttendance, setLatestAttendance] = useState(null);
  const [currentTime, setCurrentTime] = useState(new Date());
  const attendanceData = useGetLatestAttendance();
  const attendanceEvent = useCreateAttendance();

  const { deviceInformation } = useGlobal();

  useEffect(() => {
    attendanceData.mutate(undefined, {
      onSuccess: (data) => {
        if (data && data.success) {
          setLatestAttendance(data.data);
        }
      },
      onError: (error) => {
        console.error("Error fetching attendance:", error);
      },
    });
  }, []);

  useEffect(() => {
    const timer = setInterval(() => {
      setCurrentTime(new Date());
    }, 1000);
    return () => clearInterval(timer);
  }, []);

  let displayDate = formatDate(latestAttendance?.AttendanceDate);
  let displayStatus = "Clocked In";
  let displayTime = "";

  if (!latestAttendance) {
    displayDate = formatDate();
    displayStatus = "Ready to clock in?";
    displayTime = currentTime.toLocaleTimeString("en-US", {
      hour: "2-digit",
      minute: "2-digit",
    });
  } else if (latestAttendance?.TimeOut) {
    displayStatus = "Clocked Out";
    displayTime = formatTime(latestAttendance.TimeOut);
  } else if (latestAttendance?.TimeIn) {
    displayStatus = "Clocked In";
    displayTime = formatTime(latestAttendance.TimeIn);
  } else {
    displayStatus = "Ready to clock in?";
    displayTime = currentTime.toLocaleTimeString("en-US", {
      hour: "2-digit",
      minute: "2-digit",
    });
  }

  const handleSubmitAttendance = () => {
    if (!navigator.geolocation) {
      alert("Geolocation is not supported by your browser");
      return;
    }

    navigator.geolocation.getCurrentPosition(
      async (position) => {
        const { latitude, longitude } = position.coords;

        const address = await getAddressFromCoords(latitude, longitude);

        const payload = {
          sourceType: "Web",
          attendanceType: "Regular",
          fileAttached: "",
          deviceID: deviceInformation.deviceID,
          location: {
            Latitude: latitude,
            Longitude: longitude,
            Address: address,
          },
        };
        attendanceEvent.mutate(payload, {
          onSuccess: (data) => {
            console.log("Attendance submitted successfully", data);
          },
          onError: (error) => {
            const errorMsg = error?.response?.data?.message;
            if (errorMsg) return toast.info(errorMsg);
            console.error("Error submitting attendance", error);
          },
        });
      },
      (error) => {
        console.error("Error getting location:", error);
      },
      { enableHighAccuracy: true }
    );
  };

  return (
    <div className="employee-dashboard-attendance-widget">
      <div className="employee-widget-header">
        <h2>Attendance</h2>
        <div className="widget-shortcut-link">
          <i className="fa-solid fa-right-to-bracket"></i>
        </div>
      </div>

      <div className="employee-widget-body">
        <div className="attendance-widget-texts">
          <div className="attendance-widget-texts-date">
            <h3>{displayDate}</h3>
            <h1>{displayStatus}</h1>
          </div>
          <div className="attendance-widget-time">{displayTime}</div>
        </div>

        <div className="attendance-widget-actions">
          <div
            className="attendance-widget-btn"
            onClick={() => handleSubmitAttendance()}
          >
            <i className="fa-regular fa-clock"></i>
          </div>
          <div className="attendance-widget-btn">
            <i className="fa-solid fa-utensils"></i>
          </div>
        </div>
      </div>
    </div>
  );
}

export default AttendanceWidget;
